/* eslint-disable no-param-reassign */

export const bigIntChecker = (commandDataInFormParam: any) => {
  for (const key in commandDataInFormParam) {
    if (key !== 'sidc') {
      if (
        typeof commandDataInFormParam[key] === 'object' &&
        !Array.isArray(commandDataInFormParam[key]) &&
        commandDataInFormParam[key] !== null
      ) {
        const updatedCommandDataInFormEntity = commandDataInFormParam[key];
        bigIntChecker(updatedCommandDataInFormEntity);
      } else if (Array.isArray(commandDataInFormParam[key]) && commandDataInFormParam[key].length > 0) {
        commandDataInFormParam[key].forEach((item: any) => {
          bigIntChecker(item);
        });
      } else if (isBigInt(commandDataInFormParam[key])) {
        commandDataInFormParam[key] = commandDataInFormParam[key].toString();
      }
    }
  }
};

export const isBigInt = (value: any) => {
  try {
    const bigIntValue = BigInt(value);
    return bigIntValue > Number.MAX_SAFE_INTEGER || bigIntValue < Number.MIN_SAFE_INTEGER;
  } catch (e) {
    return false;
  }
};
